/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { flowRight } from 'lodash'
import Form, { Values } from 'react-trazo-forms'
import {
  getInformationFields,
  informationInitialValues,
  informationValidationSchema,
} from '../../forms/wizard/information'
import withCongress, { ComponentProps } from '../../../../providers/Congress/withCongress'
import withReservation, { ReservationProps } from '../../../../providers/Reservation/withReservation'
import { RouterItem } from '../../../../config/router.config'
import withWizardProps, { WizardProps } from '../../../../wrappers/withWizardParams'
import { getReservation, purchase, saveRegistration } from '../../../../requests/inscription'
import { uploadPDF } from '../../../../requests/gallery'
import { getNextWizardPath } from '../../../../helpers/wizard'
import { message } from 'antd'
import DetailResolver from '../../../../components/Resolvers/DetailResolver'
import LoaderWrapper from '../../../../components/Utils/LoaderWrapper'
import Row from '../../../../components/Form/Row'
import Section from '../../../../components/Section/Section'
import Col from '../../../../components/Form/Col'
import CustomButton from '../../../../components/Utils/Button'
import withURLParams, { URLParamsComponentProps } from '../../../../providers/URLParams/withURLParams'
import styled from 'styled-components'
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber} from 'react-phone-number-input'
import { countryWithCode } from '../../../../helpers/forms'
import ButtonPriceModal from '../../../../components/Modals/ButtonPriceModal'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps, URLParamsComponentProps {
  step: RouterItem;
  nextStep: RouterItem;
}

interface FormValues {
  Email?: any,
  FirstName?: any,
  LastName?: any,
  Country?: any,
  Region?: any,
  CompanyName?: any,
  JobTitle?: any,
  Gender?: any,
  AgeRange?: any,
  Voucher?: string,
  Phone?: any,
  Becado?: any,
  Course?: any,
  FileALS?: any,
  FileBLS?: any,
  AssistanceEvent?: any,
}


interface State {
  values: FormValues,
  isValid: boolean,
  isLoading: boolean,
  prices: any,
  isInitialValid: boolean,
  pdfLoading: any,
  phone: any,
  isValidPhone: boolean,
  fileALS: string,
  tempFileALS: any,
  fileALSName: string,
  fileBLS: string,
  tempFileBLS: any,
  fileBLSName: string,
}

class Courses extends React.Component<Props, State> {
  state = {
    values: {
      Email: null,
      FirstName: null,
      LastName: null,
      Country: null,
      Region: null,
      CompanyName: null,
      JobTitle: null,
      Gender: null,
      AgeRange: null,
      CouponCode: null,
      Voucher: "",
      Phone: null,
      Becado: "PAGADO PARTICULAR",
      Course: "",
      FileALS: "",
      FileBLS: "",
      AssistanceEvent: "",
    },
    phone: null,
    isValid: true,
    isLoading: false,
    prices: [],
    isInitialValid: false,
    pdfLoading: false,
    isValidPhone: false,
    fileALS: "",
    tempFileALS: "",
    fileALSName: "",
    fileBLS: "",
    tempFileBLS: "",
    fileBLSName: "",
  }

  componentDidMount () {
    const { values } = this.state
    console.log("Values: ", values)
    console.log("Values.Phone: ", values.Phone)
    const isPhoneValid = values.Phone !== "" && isValidPhoneNumber(values.Phone || "") ? true : false
    this.setState({ isValidPhone: isPhoneValid})
  }

  beforeUploadALS = (e: any) => {
    this.handleUploadFile(e.target.files[0], "als")
  }

  beforeUploadBLS = (e: any) => {
    this.handleUploadFile(e.target.files[0], "bls")
  }

  handlePhoneNumber = (val: any) => {
    let number = val ? val : ""
    const numb = parsePhoneNumber(number)
    console.log("is ok", numb)
    const isValid = val && isValidPhoneNumber(val) ? true : false
    this.setState({ phone: val, isValidPhone: isValid})
  }

  handleDownload = () => {
    window.open(`https://cdn.trazolabs.com/trazoevents/veterinario/INDICACIONES+CURSO+ONLINE.pdf`, '_blank')
  }

  handleDownloadPrices = () => {
    window.open(`https://cdn.trazolabs.com/trazoevents/veterinario/valor_talleres_laveccs_2024.jpeg`, '_blank')
  }

  handleUploadFile = async (val: any, course: string)=> {
    const { reservation } = this.props
    try {
      this.setState({ pdfLoading: true })
      if (course === "als") {
        await this.setState({ tempFileALS: val, fileALSName: val.name })
      } else {
        await this.setState({ tempFileBLS: val, fileBLSName: val.name })
      }

      const formData = new FormData()
      formData.append('CongressSlug', reservation.data.CongressSlug )
      formData.append('File', val, val.name )
      const resp = await uploadPDF( null, formData)
      if (course === "als") {
        this.setState({fileALS: resp.Data.URL})
      } else {
        this.setState({fileBLS: resp.Data.URL})
      }
    }catch(e) {
      console.log('err', e)
    } finally {
      this.setState({ pdfLoading: false })
    }
  }

  handleFormSubmit = async() => {
    const { values, fileALS, fileBLS, phone } = this.state
    const { wizard, congress } = this.props
    this.setState({ isLoading: true })

    const copyOfValues = { ...values }
    copyOfValues.FileALS = fileALS ? fileALS : values.FileALS
    copyOfValues.FileBLS = fileBLS ? fileBLS : values.FileBLS
    copyOfValues.Phone = phone

    if (values.AssistanceEvent === "Asistiré sólo al congreso") {
      copyOfValues.Course = ""
      copyOfValues.FileALS = ""
      copyOfValues.FileBLS = ""
    }


    saveRegistration({ id: wizard.token }, {
      Information: copyOfValues,
      Country: values.Country,
      Becado: values.Becado,
    })
      .then(async (resp: any) => {
        this.handleSuccess()
      })
      .catch((resp: any) => {
        message.error(resp.message)
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleSuccess = () => {
    const { history, wizard, congress, step } = this.props
    const nextPath = getNextWizardPath(wizard.token, congress.Slug, step.slug)
    history.push(nextPath)
  }

  handleResolve = async (data: any, callback: () => void) => {
    try {
      // await this.getPriceList()
      const isValid = await informationValidationSchema.validate(data.Data)
      this.setState({ isInitialValid: true, phone: data.Data.Phone || "" })
    } catch (e) {
      console.log('Initial data is not valid', e)
    } finally {
      callback()
    }
  }

  render () {
    const { reservation } = this.props

    return (
      <DetailResolver
        requestFunction={() => getReservation({ id: reservation.data.UUID })}
        render={this.renderContent}
        onResolve={this.handleResolve}
      />
    )
  }

  renderContent = (data: any) => {
    const { isLoading, isInitialValid, pdfLoading, values } = this.state
    const { congress } = this.props
    const index = countryWithCode.findIndex((country) => country.nombre == values.Country)
    const countryCode = countryWithCode[Math.max(index, 0)].iso2.toString()
    return (
      <LoaderWrapper isLoading={isLoading || pdfLoading}>
        <Form
          initialValues={informationInitialValues(data.Data)}
          fields={getInformationFields(congress.Slug)}
          validationSchema={informationValidationSchema}
          onChange={(values: Values, isValid: boolean) => this.setState({ values, isValid })}
          isInitialValid={isInitialValid}
        >
          {this.renderForm(data.Data, countryCode)}
        </Form>
      </LoaderWrapper>
    )
  }

  renderForm = (data: any, countryCode: any) => () => {
    const { fileALS, fileBLS, values } = this.state
    const { congress } = this.props

    let sourceALS = fileALS ? fileALS : values.FileALS && values.FileALS !== "" ? values.FileALS : ""
    let sourceBLS = fileBLS ? fileBLS : values.FileBLS && values.FileBLS !== "" ? values.FileBLS : ""
    console.log("sourceALS: ", sourceALS)
    if (sourceALS.endsWith("pdf")) {
      sourceALS = ""
    }

    if (sourceBLS.endsWith("pdf")) {
      sourceBLS = ""
    }

    console.log("SourceALS: ", sourceALS)
    return (
      <React.Fragment>
        <Section>
          <h2>Información de talleres de pago adicional</h2>
          <Row gutter={32} m={15}>
            <Col md={24}>
              <Form.Field name="AssistanceEvent"/>
            </Col>
          </Row>
        </Section>

        {values.AssistanceEvent !== "Asistiré sólo al congreso" ? (
          <Section>
            <Row gutter={32} m={15}>
              <Label>¿Desea inscribirse a un taller de pago adicional? <a onClick={this.handleDownloadPrices}>Ver Precios</a></Label>
              <Col md={24}>
                <Form.Field name="Course"/>
              </Col>
            </Row>
          </Section>
        ) : null}

        {values.AssistanceEvent !== "Asistiré sólo al congreso" && values.Course === "CERTIFICACION EN RCP RECOVER" ? (
          <Section>
            <Row gutter={32} style={{ marginBottom: 24}}>
              <Col >
                <h4>La inscripción para el taller Certificación en RCP Recover Requiere tener certificados de los cursos online RECOVER BLS & ALS.</h4>
                <h4>Una vez pagado, te contactaremos para entregarte tus accesos para hacer los cursos online.</h4>
              </Col>
            </Row>
          </Section>
        ) : null}


        {this.renderActionButton(data)}
      </React.Fragment>
    )
  }

  renderActionButton (data: any) {
    const { isLoading, values, fileALS, fileBLS } = this.state
    const { congress, nextStep } = this.props
    var message = ''

    if (values.AssistanceEvent === "") {
      message = 'Por favor seleccione a que evento asistirá'
    } 

    if (values.AssistanceEvent !== "Asistiré sólo al congreso" && values.Course === "" ) {
      message = 'Por favor seleccione a que taller de pago asistirá'
    }

    return (
      <Section align="center">
        <CustomButton
          disabledMessage={message}
          color={congress.PrimaryColor}
          disabled={isLoading || message !== "" }
          onClick={this.handleFormSubmit}>
          {nextStep.nextButtonLabel}
        </CustomButton>
      </Section>
    )
  }
}

const Label = styled.p`
  color: rgba(0, 0, 0, 0.85);
  text-align: start;
  position: relative;
  line-height: 39.9999px;
  white-space: nowrap;
  width: 100%;
  margin-left: 16px;
`

const VoucherContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  
  @media screen and (max-width: 768px) {
    flex-direction: col !important;
    justify-content: start;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-self: flex-start;
  margin-top: 41px;

  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
    margin-top: 20px;
    justify-content: center;
  }
`

export default flowRight([withCongress, withWizardProps, withReservation, withURLParams])(Courses)
